module.exports = __webpack_public_path__ + "static/img/sgb_logo_new.9e57d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sgb_logo_new.png
// module id = u7zL
// module chunks = 0